import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10070View from "../../Views/Bases/BM10070";
import Snackbar from "../../Components/Snackbar";

function BM10070() {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({});

  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkInputs, setCheckInputs] = React.useState({ result: false });
  const [saveData, setSaveData] = React.useState({
    lcategoCd: "",
    mcategoCd: "",
    scategoCd: "",
    screenType: "",
    result: false,
  });
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10070.GetLanguage
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              lanId: data[i].lanId,
              lanCode: data[i].lanCode,
              lanName: data[i].lanName,
              lanType: data[i].lanType,
            });
            setRowData1(Commons.InsertNumber(getRowData));
          }
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CheckKeys = async () => {
    Dialog.ProgressBar(true);
    //let getRowData = [];
    try {
      if (!checkInputs.lanId) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) =>
              f.lanId === "Snack_CheckRepresentativeName" &&
              f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      } else if (!checkInputs.lanCode) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) =>
              f.lanId === "Snack_CheckLanguageType" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10070.CheckCode,
        {
          lanId: checkInputs.lanId,
          lanCode: checkInputs.lanCode,
        }
      ).then((result) => {
        let data = result.data;
        if (data) {
          setCheckInputs({
            ...checkInputs,
            result: data,
          });
          // getRowData.push({
          //   lcategoCd: checkInputs.lcategoCd,
          //   mcategoCd: checkInputs.mcategoCd,
          //   scategoCd: checkInputs.scategoCd,
          //   screenType: checkInputs.screenType,
          //   detailCd: checkInputs1.detailCd,
          // });
          // setSaveData(getRowData);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs({
            ...checkInputs,
            lcategoCd: "",
            mcategoCd: "",
            scategoCd: "",
            screenType: "",
            detailCd: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const SaveConfirm = (_grid) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic(_grid);
      }
    );
  };

  const SaveLogic = async (_grid) => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let getSaveData = [];
    // getSaveData.push({
    //   lanId: changedRowData[0].lanId,
    //   lanData: changedRowData[0].lanData,
    //   lanName: changedRowData[0].lanName,
    //   lanType: changedRowData[0].lanType,
    // });

    let tranData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (_grid == "grid1") {
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Bases.BM10070.CreateLanguage,
          updateData
        ).then((result) => {
          let data = result.data;

          if (data !== "Ok") {
            throw new Error(data.message);
          } else if (data.type === "Error") {
            throw new Error(data.message);
          } else {
            // GetLanguage(
            //   selectedRowData[0].lcategoCd,
            //   selectedRowData[0].mcategoCd,
            //   selectedRowData[0].scategoCd
            // );
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  const GetLanguage = async (_mcategoCd) => {
    Dialog.ProgressBar(true);
    let getRowData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10070.GetLanguage,
        {
          mcategoCd: _mcategoCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              lanId: data[i].lanId,
              lanCode: data[i].lanCode,
              lanName: data[i].lanName,
              lanType: data[i].lanType,
            });
            setRowData1(Commons.InsertNumber(getRowData));
          }
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <div>
      <Bm10070View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        GetLanguage={GetLanguage}
        inputs={inputs}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        setSelectedRowData={setSelectedRowData}
        selectedRowData={selectedRowData}
        setInputs={setInputs}
        CheckKeys={CheckKeys}
        SaveConfirm={SaveConfirm}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default BM10070;
